import { useTheme as useEmotionTheme } from '@emotion/react'
import { Theme as AppTheme } from 'src/ui/style/Theme'

declare module '@emotion/react' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    export interface Theme extends AppTheme {}
}

export const useTheme = (): AppTheme => useEmotionTheme()
